// Les ROUTES de l'application, toutes dans ce fichier (docs/specs-fonctionnelles.md §4).
import { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router';
import { useMagasin } from './donnees/magasin';
import { Disposition } from './composants/Disposition';
import { Connexion } from './ecrans/Connexion';
import { MotDePasseOublie, Reinitialiser } from './ecrans/MotDePasseOublie';
import { TableauDeBord } from './ecrans/TableauDeBord';
import { Session } from './ecrans/Session';
import { Reviser } from './ecrans/Reviser';
import { Planning } from './ecrans/Planning';
import { Tableau } from './ecrans/Tableau';
import { Journal } from './ecrans/Journal';
import { Portfolio } from './ecrans/Portfolio';
import { Parcours } from './ecrans/Parcours';
import { Veille } from './ecrans/Veille';
import { Memo } from './ecrans/Memo';
import { Defis } from './ecrans/Defis';
import { Parametres } from './ecrans/Parametres';
import { Aide } from './ecrans/Aide';

export function App() {
  const { pret, utilisateur, etat } = useMagasin();
  const location = useLocation();

  // Thème clair/sombre : réglage de l'utilisateur, sinon celui du système.
  useEffect(() => {
    const systeme = window.matchMedia('(prefers-color-scheme: dark)');
    const appliquer = () => {
      const choix = etat.parametres.theme;
      const sombre = choix === 'sombre' || (choix === 'auto' && systeme.matches);
      document.documentElement.dataset['theme'] = sombre ? 'sombre' : 'clair';
    };
    appliquer();
    systeme.addEventListener('change', appliquer);
    return () => systeme.removeEventListener('change', appliquer);
  }, [etat.parametres.theme]);

  if (!pret) return <div className="connexion-page"><p className="doux">Chargement…</p></div>;

  const publique = ['/connexion', '/mot-de-passe-oublie', '/reinitialiser'].includes(location.pathname);
  // Sans utilisateur connu sur cet appareil, tout mène à la connexion (R-OFF-01 : avec un
  // utilisateur connu, l'application s'ouvre même hors ligne ou session expirée).
  if (!utilisateur && !publique) return <Navigate to="/connexion" replace />;

  return (
    <Routes>
      <Route path="/connexion" element={<Connexion />} />
      <Route path="/mot-de-passe-oublie" element={<MotDePasseOublie />} />
      <Route path="/reinitialiser" element={<Reinitialiser />} />
      <Route element={<Disposition />}>
        <Route path="/" element={<TableauDeBord />} />
        <Route path="/sessions/:id" element={<Session />} />
        <Route path="/reviser" element={<Reviser />} />
        <Route path="/planning" element={<Planning />} />
        <Route path="/tableau" element={<Tableau />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/parcours" element={<Parcours />} />
        <Route path="/veille" element={<Veille />} />
        <Route path="/memo" element={<Memo />} />
        <Route path="/defis" element={<Defis />} />
        <Route path="/parametres" element={<Parametres />} />
        <Route path="/aide" element={<Aide />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
